import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { DropZone } from '../shared/dropzone/DropZone';
import { useFileUploads } from '@texas/api/hooks/useFileUploads';
import { FileUploads } from '../shared/dropzone/FileUploads';

export function SupplierFileUploadZone({
  emailFolderId,
  documentsFolderId,
  samplesFolderId,
}: {
  emailFolderId: number;
  documentsFolderId: number;
  samplesFolderId: number;
}) {
  const { t } = useTranslation();
  const { fileUploads, uploadFiles, removeFileUpload } = useFileUploads();

  return (
    <Flex direction="column" gap={2}>
      <Text variant="header-medium">{t('fileBrowser.uploadFiles')}</Text>
      <Flex gap={10} wrap="wrap">
        <Flex direction="column" w={80} gap={1}>
          <Text variant="sub">{t('suppliers.emailsFolder')}</Text>
          <DropZone
            multiple={true}
            onUpload={(files) => uploadFiles(files, emailFolderId)}
          />
        </Flex>
        <Flex direction="column" w={80} gap={1}>
          <Text variant="sub">{t('suppliers.documentsFolder')}</Text>
          <DropZone
            multiple={true}
            onUpload={(files) => uploadFiles(files, documentsFolderId)}
          />
        </Flex>
        <Flex direction="column" w={80} gap={1}>
          <Text variant="sub">{t('suppliers.samplesFolder')}</Text>
          <DropZone
            multiple={true}
            onUpload={(files) => uploadFiles(files, samplesFolderId)}
          />
        </Flex>
      </Flex>
      <Flex py={4} pl={4} gap={4} alignContent="flex-start" flexWrap="wrap">
        <FileUploads
          fileUploads={fileUploads}
          removeFileUpload={removeFileUpload}
        />
      </Flex>
    </Flex>
  );
}
